// ----------------------------------------------------------------------------
// Component: Page Tabs
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_page-tabs.scss';
